import * as React from 'react';
import { ReactElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  BUTTON_BASE,
  BUTTON_BLOCK,
  BUTTON_DISABLED,
  BUTTON_SIZE,
  BUTTON_VARIANT,
  ButtonSize,
  ButtonVariant,
} from './variants';

type IProps = {
  children: any;
  buttonType?: ButtonVariant;
  size?: ButtonSize;
  isDisabled?: boolean;
  isBlock?: boolean;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = forwardRef<HTMLButtonElement, IProps>(
  (
    {
      children,
      buttonType = 'primary',
      size = 'default',
      isDisabled,
      isBlock,
      className,
      ...props
    },
    ref
  ): ReactElement => {
    const buttonClasses = twMerge(
      BUTTON_BASE,
      BUTTON_VARIANT[buttonType],
      BUTTON_SIZE[size],
      isBlock && BUTTON_BLOCK,
      isDisabled && BUTTON_DISABLED,
      className
    );

    return (
      <button
        className={buttonClasses}
        disabled={isDisabled}
        ref={ref}
        {...props}>
        {children}
      </button>
    );
  }
);

export default Button;
